// extracted by mini-css-extract-plugin
export default {"form":"gtQqURhYIWCaI7Qj6EzJ"};